<template>
  <div :style="{ height: '100%' }">
    <v-layout v-if="loading" align-center justify-center column fill-height>
      <v-list-item>
        <v-list-item-avatar width="55" tile height="70">
          <v-progress-circular
            indeterminate
            size="55"
            width="2"
          ></v-progress-circular>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold title"
            >Aguarde...</v-list-item-title
          >
          <v-list-item-subtitle>{{ info_loading }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-layout>
    <template v-else-if="candidato">
      <v-row dense v-if="candidato.nivel == 1">
        <v-col cols="12">
          <btn-desconectar label="Cancelar inscrição" />
        </v-col>
        <v-col cols="12" class="mt-1">
          <passos-inscricao />
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import PassosInscricao from "@/components/inscricao/PassosInscricao.vue";
import { mapActions, mapMutations, mapState } from "vuex";
import BtnDesconectar from "../components/inscricao/botoes/BtnDesconectar.vue";

export default {
  components: {
    BtnDesconectar,
    PassosInscricao,
  },
  computed: { ...mapState(["candidato"]) },
  data: () => ({
    loading: true,
    info_loading: "",
  }),
  methods: {
    ...mapMutations(["resetStateExpProf"]),
    ...mapActions([
      "getAreasInteresse",
      "getDadosGerais",
      "getEscolaridades",
      "getEmpresasFunc",
      "refreshCandidato",
    ]),
    isMobile() {
      return this.$mq == "sm";
    },
  },
  async mounted() {
    this.loading = true;

    try {
      // Garante candidato em memória se existir no sessionStorage
      if (!this.candidato) {
        try {
          await this.refreshCandidato();
        } catch (e) {
          console.error("[InscricaoView] Falha ao atualizar candidato:", e);
        }
      }

      this.resetStateExpProf();

      const steps = [
        { msg: "Buscando áreas de interesse", fn: this.getAreasInteresse },
        { msg: "Buscando escolaridades", fn: this.getEscolaridades },
        { msg: "Buscando empresas", fn: this.getEmpresasFunc },
        { msg: "Buscando dados gerais", fn: this.getDadosGerais },
      ];

      for (const step of steps) {
        this.info_loading = step.msg;
        console.time(step.msg);
        try {
          await step.fn();
          console.timeEnd(step.msg);
        } catch (e) {
          // Marca claramente qual requisição falhou para identificar o 500
          console.error(`[InscricaoView] Erro na etapa: ${step.msg}`, e);
          if (e.response) {
            console.error(
              "Status:",
              e.response.status,
              "URL:",
              e.response.config?.url,
              "Response:",
              e.response.data
            );
          }
          this.$toasted &&
            this.$toasted.error(step.msg + " falhou. Tente novamente.");
          // Interrompe as demais cargas, já que estado pode ficar inconsistente
          throw e;
        }
      }
    } catch (outer) {
      console.error("[InscricaoView] Erro geral durante o mounted:", outer);
    } finally {
      this.info_loading = "";
      this.loading = false;
    }
  },
};
</script>

<style>
.v-label {
  font-size: 0.9rem !important;
}
</style>
